import { HTMLAttributes, forwardRef } from 'react';
import { clsx } from 'clsx';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'glass' | 'gradient';
}

const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ className, variant = 'default', children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={clsx(
          'rounded-3xl transition-all duration-300',
          {
            'bg-white shadow-glass hover:shadow-glass-lg': variant === 'default',
            'glass hover:shadow-glass-lg': variant === 'glass',
            'gradient-bg text-white shadow-glass-lg': variant === 'gradient',
          },
          className,
        )}
        {...props}
      >
        {children}
      </div>
    );
  },
);

Card.displayName = 'Card';

export { Card };
